import React from 'react';

function DeleteIconIcon(props) {
  return (
    <div className="delete-icon-container">
      <svg
        type="button"
        onClick={props.delete}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) props.delete();
        }}
        version="1.1"
        tabIndex={0}
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1000 1000"
        enableBackground="new 0 0 1000 1000"
        xmlSpace="preserve"
        role="button"
      >
        <title>Delete Icon</title>
        <g>
          <path
            fill={props.color}
            d="M735.9,627.5L608.4,500l127.5-127.5c5.3-5.3,5.3-13.8,0-19.1l-89.3-89.3c-5.3-5.3-13.9-5.3-19.1,0L500,391.5L372.5,264.1c-5.1-5.1-14-5.1-19.1,0l-89.3,89.3c-2.5,2.5-4,6-4,9.6s1.4,7,4,9.6L391.6,500L264.1,627.5c-2.5,2.5-4,6-4,9.6c0,3.6,1.4,7,4,9.6l89.3,89.3c2.5,2.5,6,4,9.6,4c3.6,0,7-1.4,9.6-4L500,608.4l127.5,127.5c2.6,2.7,6.1,4,9.6,4s6.9-1.3,9.6-4l89.3-89.3C741.2,641.3,741.2,632.8,735.9,627.5z"
          />
          <path
            fill={props.color}
            d="M500,139.9c198.6,0,360.1,161.6,360.1,360.1c0,198.6-161.6,360.1-360.1,360.1S139.9,698.6,139.9,500C139.9,301.5,301.4,139.9,500,139.9 M500,10C229.4,10,10,229.4,10,500c0,270.6,219.4,490,490,490c270.6,0,490-219.4,490-490C990,229.4,770.6,10,500,10L500,10z"
          />
        </g>
      </svg>
    </div>
  );
}

export default DeleteIconIcon;
